import { openMailto } from "@/utils/mailto";
import Hero from "../components/hero";
import emergencyIcon from "@assets/icons/emergencyIcon.svg";
import heroImage from "@assets/images/bussiness-solutions.svg";
import mascotImage from "@assets/images/mascot.svg";
import macbook from "@assets/images/macbook.svg";
import {
  addson,
  billingsDetails,
  Capabilities,
  features,
  goals,
  Industries,
  offerings,
  portfolio,
  QA,
  regulations,
  Structures,
} from "../data";
import buildingIcon from "@assets/icons/building-2-fill.svg";
import mailIcon from "@assets/icons/mail-fill.svg";
import phoneIcon from "@assets/icons/phone-fill.svg";
import Contact from "../components/contact";
import Accordion from "../components/Accordion";

const heroData = {
  title:
    "Your Gas Infrastructure Partner for Buildings, Communities & Businesses",
  description:
    "we deliver end-to-end solutions for property developers, owner associations, and commercial clients from network design and installation to metering, billing, and maintenance.",
  image: heroImage,
  buttonText: "Book a consultation",
  buttonOnclick: () => openMailto({ subject: "Business Solutions Inquiry" }),
  footerText:
    "Our licensed technicians and 24/7 emergency response team are always ready to protect your home and business. ",
  footerButtonText: "Report an Emergency Online",
  footerButtonOnclick: () =>
    openMailto({
      subject: "Emergency Report",
      body: "Emergency Type:\nLocation:\nDescription:\n",
    }),
  footerIcon: <img src={emergencyIcon} alt="" className="w-8 h-8" />,
};

export default function BusinessSolution() {
  return (
    <main className="bg-white">
      <Hero data={heroData} />

      {/* Our Corporate Service Portfolio  */}
      <section className="mt-12 md:mt-16 lg:mt-24 xl:mt-[100px] px-4 md:px-6 lg:px-8">
        <h1 className="text-[28px] md:text-[36px] lg:text-[46px] xl:text-[54px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left md:text-center">
          Our Corporate Service Portfolio{" "}
        </h1>
        <div className="max-w-7xl mx-auto mt-8 md:mt-12 lg:mt-16 xl:mt-[64px]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
            {portfolio.map((data, i) => (
              <div
                key={i}
                className="w-full min-h-[200px] md:min-h-[220px] lg:min-h-[250px] border border-[#62636C33] rounded-[16px] md:rounded-[20px] lg:rounded-[24px] p-4 md:p-5 lg:p-[24px]"
              >
                <div className="flex items-center gap-2 md:gap-3 lg:gap-[12px]">
                  <span className="min-w-[60px] min-h-[60px] md:min-w-[62px] md:min-h-[62px] lg:min-w-[68px] lg:min-h-[68px] bg-black rounded-[10px] md:rounded-[11px] lg:rounded-[12px] text-white text-[18px] md:text-[18px] lg:text-[20px] font-semibold items-center justify-center flex flex-shrink-0">
                    {data.id}
                  </span>
                  <h1 className="text-[18px] md:text-[20px] lg:text-[24px] font-semibold text-[#090D2C] leading-tight">
                    {data.title}
                  </h1>
                </div>

                <h2 className="text-[16px] md:text-[16px] lg:text-[20px] mt-4 md:mt-5 lg:mt-[24px] font-normal text-[#0A0E2EBF] leading-relaxed">
                  {data.subtitle}{" "}
                </h2>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Developers & OA Choose GAZ */}

      <section className="mt-12 md:mt-16 lg:mt-24 xl:mt-[220px] px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-[89px]">
            <div className="w-full max-w-[664px] h-[350px] md:h-[500px] lg:h-[600px] xl:h-[716px] bg-[#F03813] flex items-end justify-center rounded-[16px]">
              <img
                src={mascotImage}
                alt="mascot"
                className="max-w-full h-auto"
              />
            </div>

            <div className="w-full lg:max-w-[615px]">
              <h1 className="text-[28px] md:text-[36px] lg:text-[46px] xl:text-[54px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left">
                Why Developers & OA Choose GAZ
              </h1>

              <Accordion items={QA} />
            </div>
          </div>
        </div>
      </section>

      {/* Flexible Partnership Structures  */}
      <section className="mt-12 md:mt-16 lg:mt-24 xl:mt-[170px] px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="bg-[#F1F1F1] rounded-[16px] md:rounded-[20px] lg:rounded-[24px] p-5 md:p-6 lg:p-8 xl:p-[40px]">
            <h1 className="text-[20px] md:text-[28px] lg:text-[34px] xl:text-[40px] text-[#1E1F24] font-semibold mb-5 md:mb-6 lg:mb-8 xl:mb-10">
              Flexible Partnership Structures
            </h1>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 lg:gap-6 xl:gap-8 items-start">
              {Structures.map((data, i) => (
                <div
                  key={i}
                  className="bg-white rounded-[16px] md:rounded-[20px] lg:rounded-[24px] p-4 md:p-5 lg:p-6 xl:p-[24px] min-h-[120px] md:min-h-[130px] lg:min-h-[144px]"
                >
                  <h1 className="text-[16px] md:text-[20px] lg:text-[24px] xl:text-[28px] font-semibold text-[#090D2C] break-words">
                    {data.title}{" "}
                  </h1>
                  <h2 className="text-[#0A0E2EBF] text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px] font-normal mt-3 md:mt-3.5 lg:mt-4 xl:mt-[24px] break-words leading-relaxed">
                    {data.subtitle}
                  </h2>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#F1F1F1] py-12 md:py-16 lg:py-20 xl:py-[100px] mt-12 md:mt-16 lg:mt-20 xl:mt-[100px] px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-center gap-8 md:gap-10 lg:gap-20 xl:gap-[155px]">
          <div className="w-full lg:max-w-[685px]">
            <h1 className="text-[28px] md:text-[36px] lg:text-[46px] xl:text-[54px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left">
              Smart Sub-Metering for Multi-Tenant Buildings{" "}
            </h1>
            <h2 className="text-[16px] md:text-[20px] lg:text-[22px] xl:text-[24px] text-[#62636C] font-normal leading-relaxed lg:leading-[30px] xl:leading-[34px] mt-5 md:mt-6 lg:mt-8 xl:mt-[40px]">
              GAZ provides centralized bulk metering with individual tenant
              sub-meters. Our platform generates digital invoices, collects
              payments, and remits funds to developers or OAs transparently.
            </h2>
          </div>
          <div className="w-full lg:max-w-[495px]">
            <span className="flex w-full max-w-[150px] md:max-w-[170px] lg:max-w-[186px] h-[40px] md:h-[45px] lg:h-[49px] items-center justify-center bg-[#FEF6F4] text-[#62636C] text-[18px] md:text-[20px] lg:text-[24px] font-semibold rounded-[12px] md:rounded-[14px] lg:rounded-[16px] border border-[#F03813]">
              Features
            </span>
            <div className="flex flex-col gap-3 md:gap-4 lg:gap-5 xl:gap-[24px] mt-4 md:mt-5 lg:mt-6 xl:mt-[24px]">
              {features.map((data, i) => (
                <div key={i} className="flex items-start gap-2 md:gap-3">
                  <span className="min-w-[10px] min-h-[10px] md:min-w-[12px] md:min-h-[12px] bg-[#FF2C00] rounded-full block mt-1.5 md:mt-2 flex-shrink-0"></span>
                  <h2 className="text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] font-normal leading-relaxed lg:leading-[28px] xl:leading-[32px] text-[#62636C]">
                    {data}
                  </h2>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <div className="max-w-7xl mt-12 md:mt-16 lg:mt-20 xl:mt-[100px] mx-auto px-4 md:px-6 lg:px-8">
        <h1 className="text-[28px] md:text-[36px] text-left md:text-center lg:text-[48px] xl:text-[60px] font-semibold leading-tight md:leading-normal text-[#122D63]">
          Protecting Your People and Property
        </h1>

        <div className="flex flex-col lg:flex-row gap-4 md:gap-5 lg:gap-6 xl:gap-[24px] mt-6 md:mt-8 lg:mt-10 xl:mt-[48px]">
          <div className="w-full lg:w-[672px] rounded-[16px] md:rounded-[20px] lg:rounded-[24px] min-h-[200px] md:min-h-[250px] lg:min-h-[300px] xl:min-h-[351px] bg-white p-4 md:p-5 lg:p-6 xl:p-[24px]">
            <h1 className="text-[20px] md:text-[22px] lg:text-[26px] xl:text-[28px] font-semibold text-[#090D2C]">
              Offerings
            </h1>
            <div className="flex flex-col gap-3 md:gap-4 lg:gap-5 xl:gap-[24px] mt-4 md:mt-5 lg:mt-6 xl:mt-[24px]">
              {offerings.map((data, i) => (
                <div key={i} className="flex items-start gap-2 md:gap-3">
                  <span className="min-w-[10px] min-h-[10px] md:min-w-[12px] md:min-h-[12px] rounded-full bg-[#62636C] mt-1.5 md:mt-2 flex-shrink-0"></span>
                  <h1 className="text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] text-[#62636C] font-normal leading-relaxed lg:leading-[28px] xl:leading-[32px]">
                    {data}
                  </h1>
                </div>
              ))}
            </div>
          </div>
          <div className="w-full lg:w-[672px] rounded-[16px] md:rounded-[20px] lg:rounded-[24px] min-h-[200px] md:min-h-[250px] lg:min-h-[300px] xl:min-h-[351px] bg-white p-4 md:p-5 lg:p-6 xl:p-[24px]">
            <h1 className="text-[20px] md:text-[22px] lg:text-[26px] xl:text-[28px] font-semibold text-[#090D2C]">
              Add Ons
            </h1>
            <h2 className="text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] mt-4 md:mt-5 lg:mt-6 xl:mt-[24px] text-[#62636C] font-normal leading-relaxed lg:leading-[28px] xl:leading-[32px]">
              Governance decisions follow:
            </h2>
            <div className="flex flex-col gap-3 md:gap-4 lg:gap-5 xl:gap-[24px] mt-4 md:mt-5 lg:mt-6 xl:mt-[24px]">
              {addson.map((data, i) => (
                <div key={i} className="flex items-start gap-2 md:gap-3">
                  <span className="min-w-[10px] min-h-[10px] md:min-w-[12px] md:min-h-[12px] rounded-full bg-[#62636C] mt-1.5 md:mt-2 flex-shrink-0"></span>
                  <h1 className="text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] break-words text-[#62636C] font-normal leading-relaxed lg:leading-[28px] xl:leading-[32px]">
                    {data}
                  </h1>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/*            Billing & Collection Service Details Section  */}
      <section className="mt-12 md:mt-16 lg:mt-20 xl:mt-[122px] px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-[28px] md:text-[36px] lg:text-[46px] xl:text-[54px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left md:text-center">
            Billing & Collection Service Details
          </h1>
          <div className="mt-6 md:mt-8 lg:mt-12 xl:mt-16">
            {billingsDetails.map((data, i) => (
              <div
                key={i}
                className="border-b border-[#62636C33] py-5 md:py-6 lg:py-8 xl:py-10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 md:gap-6"
              >
                <div className="flex-1">
                  <h1 className="text-[16px] md:text-[20px] lg:text-[24px] xl:text-[28px] font-semibold leading-tight md:leading-normal text-[#090D2C]">
                    {data.title}
                  </h1>
                  <h2 className="mt-3 md:mt-4 lg:mt-5 xl:mt-[24px] text-[#0A0E2EBF] text-[14px] md:text-[18px] lg:text-[20px] xl:text-[24px] font-normal leading-relaxed lg:leading-[28px] xl:leading-[32px]">
                    {data.subtitle}
                  </h2>
                </div>
                <div
                  className="min-w-[110px] md:min-w-[140px] lg:min-w-[160px] h-[32px] md:h-[34px] lg:h-[35px] p-[6px] md:p-[7px] lg:p-[8px] rounded-[8px] flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: data.color }}
                >
                  <span
                    className={`text-[13px] md:text-[14px] lg:text-[16px] font-normal ${data.color === "#C9E0FF" ? "text-black" : "text-white"}`}
                  >
                    {data.note}
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div className="w-full max-w-[1368px] min-h-[60px] md:min-h-[65px] px-4 md:px-5 lg:px-6 xl:px-[24px] py-4 gap-3 md:gap-4 lg:gap-5 xl:gap-[24px] flex flex-col md:flex-row items-start md:items-center bg-[#FEF6F4] mt-8 md:mt-12 lg:mt-16 xl:mt-[91px] border border-[#F03813] rounded-[12px] md:rounded-[14px] lg:rounded-[16px]">
            <h1 className="text-[#62636C] text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] font-bold flex-shrink-0">
              NOTE!
            </h1>
            <h2 className="text-[#62636C] text-[14px] md:text-[16px] lg:text-[20px] xl:text-[24px] font-normal leading-relaxed lg:leading-[28px] xl:leading-[32px]">
              All corporate contracts can integrate these fees directly into
              tenant invoices, ensuring seamless cost recovery.
            </h2>
          </div>
        </div>
      </section>

      <section className="mt-12 md:mt-16 lg:mt-24 xl:mt-[235px] px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 lg:gap-12 xl:justify-between">
            <div className="w-full lg:max-w-[442px]">
              <h1 className="text-[24px] md:text-[32px] lg:text-[42px] xl:text-[54px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left">
                Total Visibility. Complete Control.{" "}
              </h1>
              <h2 className="mt-6 md:mt-8 lg:mt-12 xl:mt-[80px] text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] font-normal text-[#62636C]">
                Capabilities
              </h2>
              <div className="flex flex-col gap-3 md:gap-4 lg:gap-5 xl:gap-[24px] mt-4 md:mt-5 lg:mt-6 xl:mt-[24px]">
                {Capabilities.map((data, i) => (
                  <div key={i} className="flex items-start gap-2 md:gap-3">
                    <span className="min-w-[10px] min-h-[10px] md:min-w-[12px] md:min-h-[12px] bg-[#FF2C00] rounded-full block mt-1.5 md:mt-2 flex-shrink-0"></span>
                    <h2 className="text-[14px] md:text-[18px] lg:text-[20px] xl:text-[24px] font-normal leading-relaxed lg:leading-[28px] xl:leading-[32px] text-[#62636C]">
                      {data}
                    </h2>
                  </div>
                ))}
              </div>
            </div>

            <div className="w-full lg:max-w-[647px] aspect-[647/552] pt-8 md:pt-10 lg:pt-12 xl:pt-[67px] pl-4 md:pl-5 lg:pl-6 xl:pl-[35px] rounded-[16px] md:rounded-[20px] lg:rounded-[24px] bg-[#F24D2B] flex items-start justify-start overflow-hidden">
              <img
                src={macbook}
                alt=""
                className="w-full h-full object-contain object-left-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Key Industries Served  */}
      <section className="mt-12 md:mt-16 lg:mt-20 xl:mt-[110px] px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="bg-[#F1F1F1] rounded-[16px] md:rounded-[20px] lg:rounded-[24px] p-5 md:p-6 lg:p-8 xl:p-[40px]">
            <h1 className="text-[20px] md:text-[28px] lg:text-[34px] xl:text-[40px] text-[#1E1F24] font-semibold mb-5 md:mb-6 lg:mb-8 xl:mb-10">
              Key Industries Served
            </h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 lg:gap-6 xl:gap-8">
              {Industries.map((data, i) => (
                <div
                  key={i}
                  className="bg-white rounded-[16px] md:rounded-[20px] lg:rounded-[24px] p-4 md:p-5 lg:p-6 xl:p-[24px] min-h-[110px] md:min-h-[130px] lg:min-h-[151px]"
                >
                  <h1 className="text-[16px] md:text-[20px] lg:text-[24px] xl:text-[28px] font-semibold text-[#090D2C] break-words">
                    {data.title}{" "}
                  </h1>
                  <h2 className="text-[#0A0E2EBF] text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px] font-normal mt-3 md:mt-3.5 lg:mt-4 xl:mt-[24px] break-words leading-relaxed">
                    {data.subtitle}
                  </h2>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#F1F1F1] py-12 md:py-16 lg:py-20 xl:py-[120px] mt-12 md:mt-16 lg:mt-20 xl:mt-[100px] px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="border-b border-[#B9BBC6] pb-6 md:pb-8 lg:pb-12 xl:pb-[64px]">
            <h1 className="text-[24px] md:text-[32px] lg:text-[42px] xl:text-[54px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left">
              All GAZ corporate operations adhere to:{" "}
            </h1>
            <div className="flex flex-col gap-3 md:gap-4 lg:gap-5 xl:gap-[24px] mt-5 md:mt-6 lg:mt-8 xl:mt-[24px]">
              {regulations.map((data, i) => (
                <div key={i} className="flex items-start gap-2 md:gap-3">
                  <span className="min-w-[10px] min-h-[10px] md:min-w-[12px] md:min-h-[12px] rounded-full bg-[#62636C] mt-1.5 md:mt-2 flex-shrink-0"></span>
                  <h1 className="text-[14px] md:text-[18px] lg:text-[20px] xl:text-[24px] text-[#62636C] font-normal leading-relaxed lg:leading-[28px] xl:leading-[32px] break-words">
                    {data}
                  </h1>
                </div>
              ))}
            </div>
          </div>

          <h1 className="text-[24px] md:text-[32px] mt-6 md:mt-8 lg:mt-12 xl:mt-[64px] lg:text-[42px] xl:text-[54px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left">
            Helping You Meet UAE Net Zero 2050 Goals{" "}
          </h1>
          <div className="flex flex-col gap-3 md:gap-4 lg:gap-5 xl:gap-[24px] mt-5 md:mt-6 lg:mt-8 xl:mt-[24px]">
            {goals.map((data, i) => (
              <div key={i} className="flex items-start gap-2 md:gap-3">
                <span className="min-w-[10px] min-h-[10px] md:min-w-[12px] md:min-h-[12px] rounded-full bg-[#62636C] mt-1.5 md:mt-2 flex-shrink-0"></span>
                <h1 className="text-[14px] md:text-[18px] lg:text-[20px] xl:text-[24px] text-[#62636C] font-normal leading-relaxed lg:leading-[28px] xl:leading-[32px] break-words">
                  {data}
                </h1>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Contact Section */}
      <div className="mx-auto py-12 md:py-16 lg:py-20 xl:py-[100px] px-4 md:px-6 lg:px-8">
        <Contact
          title="Need Help with your Bill or Account"
          subtitle="Call our 24/7 Emergency Line: 800-GAZ (42747) or report a concern via our Online Safety Form."
          cardTitle="Book Consultation"
          contactDetails={[
            { title: "help@gazglobal.net", icon: mailIcon },
            { title: "Support (8 AM – 8 PM)", icon: phoneIcon },
            { title: "Sunday – Thursday (8 AM – 6 PM)", icon: buildingIcon },
          ]}
        />
      </div>
    </main>
  );
}
